import type { ConsumptionLocale } from "@/locales/fr/consumption";

const consumptionLocale: ConsumptionLocale = {
  consumption: {
    consumptions: "Consumptions",
  },
};

export default consumptionLocale;
